import React from "react";
import Home from "./Page/Home";
import HowItWork from "./Page/HowItWork";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import About from "./Page/About";
import Faq from "./Page/Faq";
import Include from "./Page/Include";
import CareGiver from "./Page/CareGiver";
import GetCertified from "./Page/GetCertified";
import ContactUs from "./Page/ContactUs";
import Unsubscribe from "./Page/Unsubscribe";
import { useEffect } from "react";

const LoginRedirect = () => {
  useEffect(() => {
    window.location.href = "https://stg.admin.angelwatchedu.org/login";
  }, []);
  return null;
};

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/howItWork" element={<HowItWork />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/include" element={<Include />} />
          <Route path="/CareGiver" element={<CareGiver />} />
          <Route path="/getCertified" element={<GetCertified />} />
          <Route path="/contactUs" element={<ContactUs />} />
          <Route path="/login" element={<LoginRedirect />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
